export enum ConfirmDialogType {
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  CONFIRM_SAVE = 'CONFIRM_SAVE',
}
